var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT } from "../Infra/i18next";
import { uniques } from "healthex-common/utils";
const t = getObservableT("patients");
export class DocumentRetrievalDocumentSelectionViewModel {
    constructor(props) {
        this.footerText = NOT_LOADED;
        this.sharingOrgsDialogOpen = false;
        this.parentModel = props.model;
        this.patientConsentUIManager = props.container.patientConsentUIManager;
    }
    run() {
        if (this.patientConsentUIManager.isInteractivePreview || this.patientConsentUIManager.isScreenshotPreviewMode) {
            this.footerText = null;
        }
        else {
            void this.loadSharedOrgNames();
        }
    }
    stop() { }
    async loadSharedOrgNames() {
        var _a;
        const orgListItemInfo = (_a = (await this.patientConsentUIManager.getOptedInStudyConsentsByOrg())) !== null && _a !== void 0 ? _a : [];
        if (orgListItemInfo.length === 0) {
            this.footerText = null;
            return;
        }
        switch (orgListItemInfo.length) {
            case 1:
                this.footerText = t("By continuing, these records will also be shared with <openShareModal>{{ orgName }}</openShareModal> that you're currently sharing with. You can manage this at any time on HealthEx.", { orgName: orgListItemInfo[0].orgName });
                break;
            case 2:
                this.footerText = t("By continuing, these records will also be shared with <openShareModal>{{ orgName1 }} and {{ orgName2 }}</openShareModal> that you're currently sharing with. You can manage this at any time on HealthEx.", { orgName1: orgListItemInfo[0].orgName, orgName2: orgListItemInfo[1].orgName });
                break;
            case 3:
                this.footerText = t("By continuing, these records will also be shared with <openShareModal>{{ orgName1 }}, {{ orgName2 }}, and 1 other</openShareModal> that you're currently sharing with. You can manage this at any time on HealthEx.", { orgName1: orgListItemInfo[0].orgName, orgName2: orgListItemInfo[1].orgName });
                break;
            default:
                this.footerText = t("By continuing, these records will also be shared with <openShareModal>{{ orgName1 }}, {{ orgName2 }}, and {{ count }} others</openShareModal> that you're currently sharing with. You can manage this at any time on HealthEx.", { orgName1: orgListItemInfo[0].orgName, orgName2: orgListItemInfo[1].orgName, count: orgListItemInfo.length - 2 });
                break;
        }
    }
    get isFastenAuthLoading() {
        return this.parentModel.isAuthLoading;
    }
    get fastenPublicId() {
        return this.parentModel.fastenPublicId;
    }
    get fastenPatientId() {
        return this.parentModel.fastenPatientId;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get showFastenImmediately() {
        if (this.parentModel.isScreenshotMode)
            return false;
        return this.parentModel.uiState.showFastenImmediately;
    }
    fastenShown() {
        this.parentModel.uiState.showFastenImmediately = false;
    }
    get locationList() {
        return this.parentModel.locationList.filter((location) => !location.isPrevious);
    }
    get previousLocationList() {
        return this.parentModel.locationList.filter((location) => location.isPrevious);
    }
    get hasPreviousLocations() {
        return this.previousLocationList.length > 0;
    }
    get commonPreviousLocationsDate() {
        const dates = this.previousLocationList.map((location) => { var _a, _b; return (_b = (_a = location.updatedAt) === null || _a === void 0 ? void 0 : _a.toLocaleDateString()) !== null && _b !== void 0 ? _b : ""; });
        const uniqueDates = uniques(dates);
        if (uniqueDates.length !== 1)
            return null;
        return uniqueDates[0];
    }
    get previousLocationsCanBeUpdatedWithCLEAR() {
        return !this.patientConsentUIManager.useTefca;
    }
    excludeLocation(location) {
        this.parentModel.onLocationExcluded(location);
    }
    includeLocation(location) {
        this.parentModel.onLocationIncluded(location);
    }
    showSharingOrgsDialog() {
        this.sharingOrgsDialogOpen = true;
    }
    hideSharingOrgsDialog() {
        this.sharingOrgsDialogOpen = false;
    }
    async logInToLocation(location) {
        this.parentModel.retryLocations([location]);
    }
}
__decorate([
    observable
], DocumentRetrievalDocumentSelectionViewModel.prototype, "footerText", void 0);
__decorate([
    observable
], DocumentRetrievalDocumentSelectionViewModel.prototype, "sharingOrgsDialogOpen", void 0);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "isFastenAuthLoading", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "showFastenImmediately", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "locationList", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "previousLocationList", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "hasPreviousLocations", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "commonPreviousLocationsDate", null);
__decorate([
    computed
], DocumentRetrievalDocumentSelectionViewModel.prototype, "previousLocationsCanBeUpdatedWithCLEAR", null);
